import { render, staticRenderFns } from "./AppDeprecationNotice.vue?vue&type=template&id=3b1f9504&scoped=true&"
import script from "./AppDeprecationNotice.vue?vue&type=script&lang=js&"
export * from "./AppDeprecationNotice.vue?vue&type=script&lang=js&"
import style0 from "./AppDeprecationNotice.vue?vue&type=style&index=0&id=3b1f9504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1f9504",
  null
  
)

export default component.exports